









import {Component, Prop, Vue} from "vue-property-decorator";
import {UserProfile} from "../../../api/models/UserProfile";

@Component({
  name: "UserIcon"
})
export default class UserIcon extends Vue {
  @Prop({required: true, default: null}) profile: UserProfile | null;

  backend = '';
  couldntLoadProfileImg = false;

  get initials(): string | undefined {
    return this.profile?.initials;
  }

  get userProfileColor(): string | undefined {
    return this.profile?.profileColor;
  }

  get profilePhotoLink(): string | undefined {
    return this.backend ? this.profile?.profilePhotoLink(this.backend) : '';
  }

  created() {
    this.backend = this.$store.state.session.backend;
  }

  onImgError() {
    this.couldntLoadProfileImg = true;
  }
}
